"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.t = exports.setupMessages = void 0;
const intl_messageformat_1 = require("intl-messageformat");
let initialized = false;
let messages = {};
const isLocal = process.env.ENVIRONMENT === "local";
const isTest = process.env.ENVIRONMENT === "test";
const setupMessages = (resource) => {
    messages = resource;
    initialized = true;
};
exports.setupMessages = setupMessages;
const t = (key, variables, _metadata) => {
    if (isLocal && !initialized) {
        console.error(`t() was called before setupMessages() for key ${key}`);
    }
    const missing = isTest ? key : `missing key ${key}`;
    const result = new intl_messageformat_1.IntlMessageFormat(messages[key] ?? missing).format({
        ...variables,
    });
    return result ?? missing;
};
exports.t = t;
//# sourceMappingURL=t.js.map